import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Task } from 'crono-fe-common/types/task';

export type GetTaskEmailParams = {
  prospectId?: string;
  emailId?: number;
  withLog: boolean;
};

export default function useGetTaskEmail(params: GetTaskEmailParams) {
  const queryParams = queryString.stringify(params);

  const request: Request = {
    url: `${ENDPOINTS.events.task.email}?${queryParams}`,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [
      ENDPOINTS.events.task.email,
      params.prospectId,
      params.emailId,
      params.withLog,
    ],
    queryFn: () => client(request),
    staleTime: 5 * 60 * 1000,
    enabled: params.prospectId !== undefined && params.emailId !== undefined,
  };

  const { data, ...rest } = useQuery<Response<Task | null>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
